import type { AgentStatus } from 'agentic_chat/types';

import createStore from './store';

/**
 * AI Edits Store - Reactive UI state for AI Edits functionality
 *
 * This store manages UI state that needs to be reactive across content-studio.
 *
 * State:
 * - agentStatus: Current AI agent status (Idle, Planning, Processing, etc.)
 * - isSendingMessage: Whether a message is being sent (disables UI)
 * - isAIEditsSidebarOpen: Whether AI Edits sidebar is open
 */

export interface AIEditsStoreState {
  agentStatus: AgentStatus;
  isSendingMessage: boolean;
  isAIEditsSidebarOpen: boolean;
  sidebarOpenTrigger?: 'AutoOpen' | 'ManualClick';
  hadInteraction: boolean;
}

const initialState: AIEditsStoreState = {
  agentStatus: { state: 'Idle' },
  isSendingMessage: false,
  isAIEditsSidebarOpen: false,
  sidebarOpenTrigger: undefined,
  hadInteraction: false
};

const store = createStore<AIEditsStoreState>(initialState);
export const aiEditsStore = {
  ...store,
  setAgentStatus: (status: AgentStatus) =>
    store.update(draft => {
      draft.agentStatus = status;
    }),
  setIsSendingMessage: (sending: boolean) =>
    store.update(draft => {
      draft.isSendingMessage = sending;
    }),
  setIsAIEditsSidebarOpen: (open: boolean, trigger?: 'AutoOpen' | 'ManualClick') =>
    store.update(draft => {
      draft.isAIEditsSidebarOpen = open;
      if (open && trigger) {
        draft.sidebarOpenTrigger = trigger;
        draft.hadInteraction = false;
      }
    }),
  setHadInteraction: (hadInteraction: boolean) =>
    store.update(draft => {
      draft.hadInteraction = hadInteraction;
    }),
  reset: () => store.set(() => initialState)
};
